import { render, staticRenderFns } from "./1.vue?vue&type=template&id=978b9faa&scoped=true&"
import script from "./1.vue?vue&type=script&lang=ts&"
export * from "./1.vue?vue&type=script&lang=ts&"
import style0 from "./1.vue?vue&type=style&index=0&id=978b9faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978b9faa",
  null
  
)

export default component.exports